import React from 'react';

import { connect } from 'react-redux';
import { Formik, Field } from 'formik';

import { PAGES } from '../../config/constants';
import GooglePlace from '../../components/GooglePlaces';
import ScreenWrapper from '../../components/ScreenWrapper';

const PropertyAddress = ({ place, setPlaceData, setPrevPage }) => {
  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
        }}
      >
        Property address for the loan
      </h1>

      <ScreenWrapper step={6}>
        <Formik
          initialValues={{ ...place }}
          onSubmit={values => {
            setPlaceData(values);
          }}
        >
          {({ handleSubmit }) => (
            <React.Fragment>
              <Field
                name="place_id"
                component={GooglePlace}
                cstmOnChange={async () => {
                  await Promise.resolve();

                  handleSubmit();
                }}
              />

              <div style={{ marginTop: 10 }}>
                <div style={{ float: 'left' }}>
                  <button type="button" className="cstm_btn cstm_btn-text" onClick={setPrevPage}>
                    Back
                  </button>
                </div>
                <div style={{ float: 'right' }}>
                  <button type="button" className="cstm_btn cstm_btn-blue" onClick={handleSubmit}>
                    Next
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const mapState = state => {
  return {
    place: state.place,
  };
};

const mapDispatch = dispatch => {
  return {
    setPlaceData: values => {
      dispatch({
        type: 'SET_PLACE_DATA',
        payload: values,
      });

      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.CONSOLE_BROOK_1,
      });
    },
    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.BORROWER_CREDIT,
      });

      dispatch({
        type: 'SET_BORROWER_INFO',
        payload: {
          backButton: true,
        },
      });
    },
  };
};

export default connect(mapState, mapDispatch)(PropertyAddress);



// WEBPACK FOOTER //
// ./src/Screens/PropertyAddress/index.js